"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.extractAirportAppliedFilters = extractAirportAppliedFilters;
exports.extractAppliedFilters = extractAppliedFilters;
exports.extractMultiSelectAppliedFilters = extractMultiSelectAppliedFilters;
exports.extractNestedMultiSelectAppliedFilters = extractNestedMultiSelectAppliedFilters;
exports.extractPriceAppliedFilters = extractPriceAppliedFilters;
exports.extractToggledAppliedFilters = extractToggledAppliedFilters;
exports.getAvailableAppliedFilters = getAvailableAppliedFilters;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _concat2 = _interopRequireDefault(require("lodash/concat"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _without2 = _interopRequireDefault(require("lodash/without"));
var _filter2 = require("./filter.utils");
var _filter3 = _interopRequireDefault(require("lodash/filter"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function extractPriceAppliedFilters(filterState) {
  var min = filterState.min,
    max = filterState.max,
    from = filterState.from,
    to = filterState.to;
  if (from <= min && to >= max) {
    return [];
  }
  return {
    id: 'price',
    info: {
      key: 'price',
      from: from,
      to: to
    },
    removalMode: 'reset'
  };
}
function extractMultiSelectAppliedFilters(filterKey, filterState, initialPayload) {
  if (initialPayload === void 0) {
    initialPayload = {};
  }
  var appliedFilters = [];
  (0, _each2.default)(filterState, function (_ref) {
    var code = _ref.code,
      selected = _ref.selected;
    if (selected) {
      var info = _objectSpread(_objectSpread({}, initialPayload), {}, {
        code: code,
        key: filterKey
      });
      appliedFilters.push({
        id: (0, _filter2.generateFilterId)(info),
        info: info,
        removalMode: 'toggle'
      });
    }
  });
  return appliedFilters;
}
function extractNestedMultiSelectAppliedFilters(filterKey, filterState) {
  return (0, _flatMap2.default)(filterState, function (legFilterState, index) {
    return extractMultiSelectAppliedFilters(filterKey, legFilterState, {
      index: index
    });
  });
}
function extractAirportAppliedFilters(filterState) {
  return (0, _flatMap2.default)(filterState, function (legFilterState, index) {
    return [].concat(extractMultiSelectAppliedFilters('airport', legFilterState.origin, {
      index: index,
      type: 'origin'
    }), extractMultiSelectAppliedFilters('airport', legFilterState.destination, {
      index: index,
      type: 'destination'
    }));
  });
}
function extractToggledAppliedFilters(filterKey, value) {
  var appliedFilter = [];
  if (value) {
    appliedFilter.push({
      id: filterKey,
      info: {
        value: value,
        key: filterKey
      },
      removalMode: 'toggle'
    });
  }
  return appliedFilter;
}
function extractAppliedFilters(filtersState) {
  var appliedFilters = [];
  if ((0, _isEmpty2.default)(filtersState)) {
    return appliedFilters;
  }
  (0, _each2.default)(filtersState, function (filterValue, filterKey) {
    switch (filterKey) {
      case 'airline':
        appliedFilters = (0, _concat2.default)(appliedFilters, extractMultiSelectAppliedFilters(filterKey, filtersState.airline));
        break;
      case 'airport':
        appliedFilters = (0, _concat2.default)(appliedFilters, extractAirportAppliedFilters(filtersState.airport));
        break;
      case 'price':
        appliedFilters = (0, _concat2.default)(appliedFilters, extractPriceAppliedFilters(filtersState.price));
        break;
      case 'stop':
        appliedFilters = (0, _concat2.default)(appliedFilters, extractMultiSelectAppliedFilters(filterKey, filtersState.stop));
        break;
      case 'maxStop':
        appliedFilters = (0, _concat2.default)(appliedFilters, extractMultiSelectAppliedFilters(filterKey, filtersState.maxStop));
        break;
      case 'departureTime':
        appliedFilters = (0, _concat2.default)(appliedFilters, extractNestedMultiSelectAppliedFilters(filterKey, filtersState.departureTime));
        break;
      case 'arrivalTime':
        appliedFilters = (0, _concat2.default)(appliedFilters, extractNestedMultiSelectAppliedFilters(filterKey, filtersState.arrivalTime));
        break;
      default:
        break;
    }
  });
  return appliedFilters;
}
function getAvailableAppliedFilters(appliedFilters, searchTopAirlines) {
  return (0, _filter3.default)(appliedFilters, function (appliedFilter) {
    var _appliedFilter$info = appliedFilter.info,
      code = _appliedFilter$info.code,
      key = _appliedFilter$info.key;
    var isNonStop = ['stop', 'maxStop'].includes(key) && code === 0;
    return !searchTopAirlines.includes(code) && !isNonStop;
  });
}
function getAppliedFilters(filtersParams, prevAppliedFilters) {
  var initialAppliedFilters = Array(prevAppliedFilters.length);
  (0, _each2.default)(extractAppliedFilters(filtersParams), function (appliedFilter) {
    var index = (0, _findIndex2.default)(prevAppliedFilters, {
      id: appliedFilter.id
    });
    if (index === -1) {
      initialAppliedFilters.push(appliedFilter);
    } else {
      initialAppliedFilters[index] = appliedFilter;
    }
  });
  return (0, _without2.default)(initialAppliedFilters, undefined);
}
var _default = exports.default = getAppliedFilters;